import React from 'react';
import { connect } from 'react-redux';
import { Box } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { HexToRgb, GetCssRgba } from '../../../../../../utilities/colorUtilities';

const styles = theme => ({
    colorCircle: {
        boxShadow: theme.shadows[1],
        width: theme.spacing(3),
        height: theme.spacing(3),
        borderRadius: theme.spacing(3),
    }
});

const WaveLayerIcon = (props) => {
    const { classes, waveLayerFillColor, waveLayerFillAlpha, waveLayerLineColor, waveLayerLineAlpha, waveLayerLineWidth } = props;

    let fillColor = HexToRgb(waveLayerFillColor);
    fillColor.a = waveLayerFillAlpha;

    let lineColor = HexToRgb(waveLayerLineColor);
    lineColor.a = waveLayerLineAlpha;

    return (
        <Box
            style={{
                background: GetCssRgba(fillColor),
                border: `${waveLayerLineWidth <= 5 ? waveLayerLineWidth : 5}px solid ${GetCssRgba(lineColor)}`,
            }}
            className={classes.colorCircle}
        />
    );
};

const mapStateToProps = (state, { index }) => {
    const {
        fillColor: waveLayerFillColor,
        fillAlpha: waveLayerFillAlpha,
        lineColor: waveLayerLineColor,
        lineAlpha: waveLayerLineAlpha,
        lineWidth: waveLayerLineWidth
    } = state.createPreview.present.videoSettings.visualizer.waveCircles[index];

    return {
        waveLayerFillColor,
        waveLayerFillAlpha,
        waveLayerLineColor,
        waveLayerLineAlpha,
        waveLayerLineWidth
    };
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(WaveLayerIcon, styles));